export default "__VITE_ASSET__CuGJPNrw__"